import { BaseMark } from '../BaseMark.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'tripli';
const args = {};

export class Tripli extends BaseMark {
  constructor() {
    super(glyphname, args);
  }
}
